import consumer from "./consumer"

function connectSmsChannel() {
  consumer.subscriptions.create("SmsChannel", {
    connected() {
      console.log('Cable \'SmsChannel\' connected')
    },
  
    disconnected() {
      console.log('Cable \'SmsChannel\' disconnected')
    },
  
    received(data) {
      if (data != '') {
        var smsContainer = document.getElementById("sms-container") ;
        smsContainer.innerHTML = data
        smsContainer.scrollTop = 0
      }
    }
  });
}


window.connectSmsChannel = connectSmsChannel;